import { TableBodyRow, TableHeadCell, TableHeadRow } from '@trackman/web-shared-components';
import React from 'react';
import styled from 'styled-components';

export const StyledTableHeadRow = styled((props) => <TableHeadRow {...props} />)`
  &&& {
    height: 8vh;
    max-height: 70px;
    min-height: 60px;
  }
` as typeof TableHeadRow;

export const StyledTableHeadCell = styled((props) => <TableHeadCell {...props} />)`
  &&& {
    font-size: 15px;
  }
` as typeof TableHeadCell;

export const StyledTableBodyRow = styled((props) => <TableBodyRow {...props} />)`
  &&& {
    height: 5.5vh;
    max-height: 56px;
    min-height: 45px;
  }
` as typeof TableBodyRow;

export const TableBodyContent = styled.div`
  overflow-y: scroll;
  height: calc(100vh - 420px);
`;
